import React from "react";
import { Box, Typography, IconButton } from "@mui/material";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import InstagramIcon from "@mui/icons-material/Instagram";
import CodeIcon from "@mui/icons-material/Code";
import ArticleIcon from "@mui/icons-material/Article";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "background.default",
        padding: (theme) => theme.spacing(8, 2),
        textAlign: "center",
        borderTop: "1px solid rgba(255,255,255,0.05)",
      }}
    >
      <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 800, 
            mb: 4,
            background: "linear-gradient(135deg, #00E5FF 0%, #7C4DFF 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: "inline-block"
          }}
        >
          SARTHAK SINGH
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mb: 4 }}>
          {[
            { icon: <GitHubIcon />, url: "https://github.com/sarthak03dot" },
            { icon: <LinkedInIcon />, url: "https://in.linkedin.com/in/sarthak03dot" },
            { icon: <InstagramIcon />, url: "https://www.instagram.com/sarthak03dot/" },
            { icon: <CodeIcon />, url: "https://leetcode.com/u/sarthak03dot/" },
            { icon: <ArticleIcon />, url: "https://dev.to/sarthak03dot" }
          ].map((social, i) => (
            <IconButton 
              key={i}
              href={social.url}
              target="_blank"
              sx={{ 
                color: "text.secondary",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "primary.main",
                  transform: "translateY(-5px)"
                }
              }}
            >
              {social.icon}
            </IconButton>
          ))}
        </Box>

        <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.05)", pt: 4 }}>
          <Typography variant="body2" color="text.secondary" sx={{ opacity: 0.7 }}>
            &copy; {new Date().getFullYear()} Sarthak Singh. Built with passion and code.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;